var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.logs),function(error,index){return _c('vs-card',{key:index,class:{'log-success': error.success, 'log-error': !error.success}},[_c('div',[_vm._v(_vm._s(error.url))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }